function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.002 40.44h54.054v7.371H1.002z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.002 47.84h6.143v6.143H1.002zM48.914 47.84h6.143v6.143h-6.143z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.002 40.44c0-6.143-1.224-12.285 26.908-12.285s26.908 6.143 27.152 12.285"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.458 32.44V15.716c0-1.248 1.025-2.252 2.298-2.252h44.956c1.273 0 2.297 1.004 2.297 2.252V32.86"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.058 29.04v-5.774c0-1.361 1.118-2.457 2.506-2.457h9.73c1.389 0 2.506 1.096 2.506 2.457v4.875M44 29.04v-5.774c0-1.361-1.118-2.457-2.506-2.457h-9.73c-1.389 0-2.506 1.096-2.506 2.457v4.875"
})));

var SvgBed = function SvgBed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bed.046a967e.svg";
export { ForwardRef as ReactComponent };